import { withViewComponent } from '@updater-legacy/components/custom-element';
import '../offer-card';
import '../chip';
import '@updater-components/content-container';
import '@updater-components/cta';
import '@updater-components/fa-icon';
import { ENVIRONMENT } from '../../../../../environment/';
import styles from './index.css';

class OfferDetails extends withViewComponent(styles)() {
  static props = ['offer'];

  select = (offer) => () =>
    this.dispatchEvent(
      new CustomEvent('select', {
        detail: {
          packageName: offer.id,
        },
        composed: true,
        bubbles: true,
      })
    );

  updated({ offer }) {
    // prettier-ignore
    this.render`
      <upd-content-container hover>
        <div id="provider">
          <img src=${`${ENVIRONMENT.endpoints.cloudinary}/c_scale,h_60/${offer.provider.logo}`} />
          <strong>${offer.name}</strong>
          ${offer.bonuses.map(b => this.wire(b)`
            <upd-home-security-chip>${b}</upd-home-security-chip> 
          `)}
        </div>
        <div id="rate">
          <upd-home-security-offer-card offer=${offer}>
          </upd-home-security-offer-card>
          <upd-cta primary>
            <button onclick=${this.select(offer)} type="button"> Select Package </button>
          </upd-cta>
        </div>
      </upd-content-container>
      <div id="break"></div>
    `;
  }
}

customElements.define('upd-home-security-offer-details', OfferDetails);
